import common from './en-US/common';
import metric from './en-US/metric';
import topcharts from './en-US/topcharts';
/** 表格等文本提示 */
import infoDoc from './en-US/infoDoc';
// 下载页面
import downloadPage from './en-US/downloadPage';
// compare功能
import Compare from './en-US/compare';
// 相对时间筛选器
import rangeMonthPicker from './en-US/rangeMonthPicker';
// 公司榜单
import company from './en-US/company';
// 指标
import metricSubValue from './en-US/metricSubValue';
// storeRank
import storeRank from './en-US/storeRank';
// 游戏推荐
import trending from './en-US/trending';
// Sum、Avg、Max 指标组合 中英文翻译
import calcMetrics from './en-US/calcMetrics';
// Global View
import globalView from './en-US/globalView';
// 分页器
import pagination from './en-US/pagination';
// Reports 界面
import reports from './en-US/reports';
// mobile Device
import mobileDevice from './en-US/mobileDevice';
// genre profile
import genreProfile from './en-US/genreProfile';
// marketProfile
import marketProfile from './en-US/marketProfile';
// source & metrics
import sourceMetrics from './en-US/sourceMetrics';
// streaming榜单
import streaming from './en-US/streaming';
// 筛选器保存
import filterSave from './en-US/filterSave';
// pcConsoleBenchmark页面
import pcConsoleBenchmark from './en-US/pcConsoleBenchmark';
// mobile game Benchmark页面
import mobileGameBenchmark from './en-US/mobileGameBenchmark';
// Metrics Creditability
import metricsCreditability from './en-US/metricsCreditability';
import userGuide from './en-US/guide';
import overlapAnalysis from './en-US/overlapAnalysis';
// 文本不需要翻译，用于避免报错
import text from './en-US/text';
// PC&Console 宽表 metric 修改后，筛选项变动弹窗
import filterTipModal from './en-US/filterTipModal';
// 无需翻译，但不带key会报错
import noTranslate from './en-US/noTranslate';
// 复用页面
import reusePages from './en-US/reusePages';
// CasualGenreProfile页面
import CasualGenreProfile from './en-US/CasualGenreProfile';
// mobile 游戏详情页 countries 标签页卡片标题
import mobileDetailCountriesCardTitle from './en-US/mobileDetailCountriesCardTitle';

export default {
  ...common,
  ...metric,
  ...topcharts,
  ...infoDoc,
  ...downloadPage,
  ...Compare,
  ...rangeMonthPicker,
  ...company,
  ...metricSubValue,
  ...storeRank,
  ...trending,
  ...calcMetrics,
  ...globalView,
  ...pagination,
  ...reports,
  ...mobileDevice,
  ...genreProfile,
  ...marketProfile,
  ...sourceMetrics,
  ...streaming,
  ...filterSave,
  ...pcConsoleBenchmark,
  ...mobileGameBenchmark,
  ...metricsCreditability,
  ...userGuide,
  ...overlapAnalysis,
  ...text,
  ...filterTipModal,
  ...noTranslate,
  ...reusePages,
  ...CasualGenreProfile,
  ...mobileDetailCountriesCardTitle,
};
